export type PasswordStrengthResult = {
  percent: number
  status: 'normal' | 'exception' | 'active' | 'success'
  text: string
}

export const validatePasswordPolicy = (password: string): string | undefined => {
  if (password.length < 8) return '密码长度不能少于8位'
  if (password.length > 64) return '密码长度不能超过64位'
  if (!/[A-Z]/.test(password)) return '需包含至少一个大写字母'
  if (!/[a-z]/.test(password)) return '需包含至少一个小写字母'
  if (!/\d/.test(password)) return '需包含至少一个数字'
  return undefined
}

export const passwordPolicyValidator = (_: unknown, value?: string): Promise<void> => {
  if (!value) return Promise.resolve()
  const issue = validatePasswordPolicy(value)
  return issue ? Promise.reject(new Error(issue)) : Promise.resolve()
}

export const getPasswordStrength = (password: string): PasswordStrengthResult => {
  if (!password) return { percent: 0, status: 'normal', text: '' }
  if (validatePasswordPolicy(password)) return { percent: 33, status: 'exception', text: '弱' }

  let score = 0
  if (/[A-Z]/.test(password)) score++
  if (/[a-z]/.test(password)) score++
  if (/\d/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++
  if (password.length >= 12) score++

  if (score === 3) return { percent: 66, status: 'active', text: '中' }
  return { percent: 100, status: 'success', text: '强' }
}
